import React from 'react';

const ProcessingView = ({ notes }) => {
  return (
    <div className="h-[calc(100vh-4rem)] bg-gradient-to-br from-teal-50 to-blue-50 overflow-y-auto">
      <div className="max-w-4xl mx-auto px-6 py-4">
        {/* Header */}
        <div className="text-center mb-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">FIM/FAM Assessment</h2>
          <p className="text-gray-600">AI-powered clinical assessment generation</p>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-xl shadow-lg p-6 border-2 border-gray-200">
          {/* Clinical Notes */}
          <div className="mb-4">
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Clinical Notes
            </label>
            <textarea
              value={notes}
              disabled
              className="w-full h-[calc(100vh-32rem)] min-h-[250px] p-4 border-2 border-gray-300 rounded-lg resize-none text-gray-800 bg-gray-50"
            />
          </div>

          {/* Processing Indicator */}
          <div className="bg-teal-100 rounded-lg p-4">
            <div className="flex items-center justify-center gap-3 mb-2">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-teal-600"></div>
              <span className="text-teal-800 font-semibold">Analyzing notes...</span>
            </div>
            <div className="w-full bg-teal-200 rounded-full h-2 overflow-hidden">
              <div className="bg-teal-600 h-full animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessingView;

